<app-preloader *ngIf="isLoading | async"></app-preloader>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
